// angular
import { NgOptimizedImage } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// types
import { IAuction } from '@app/+auctions/shared/types/auctions.type';
// pipes
import { TranslateDataPipe } from '@app/shared/pipes/translate-data.pipe';
import { ImageSourcePipe } from '@app/shared/pipes/image-source.pipe';

@Component({
  selector: 'pwj-auction-lot-info',
  standalone: true,
  imports: [TranslateModule, TranslateDataPipe, NgOptimizedImage, ImageSourcePipe],
  templateUrl: './auction-lot-info.component.html',
  styleUrl: './auction-lot-info.component.scss',
})
export class AuctionLotInfoComponent {
  auction = input.required<IAuction>();
}
